/** @internal */
export const MessageId = 'agent.watchdog.status';
